export const SET_LOADER = "SET_LOADER";
export const SET_NAVBAR = "SET_NAVBAR";
export const SET_CONFIRM_DIALOG = "SET_CONFIRM_DIALOG";
export const RESET_CONFIRM_DIALOG = "RESET_CONFIRM_DIALOG";
export const SET_GLOBALALERT = "SET_GLOBALALERT";
export const RESET_GLOBALALERT = "RESET_GLOBALALERT";
export const SET_USER = "SET_USER";
export const RESET_USER = "RESET_USER";
export const DRAWER = "DRAWER";

